var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isReady && _vm.clientVerified)?_c('router-view'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }